import { Grid, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { DEFAULT_EMAIL_MESSAGES, RECOMMENDATION_MESSAGES } from '../utility/Constant';

const AddNotesSection = ({ control, country }) => {
    const recommendationPlaceholder = RECOMMENDATION_MESSAGES[country] || RECOMMENDATION_MESSAGES.km;

    return (
        <Grid item container xs={12} marginTop={'24px'} className="customBoxWrapper" style={{ paddingLeft: '0', paddingRight: '0' }}>
            <Grid container alignItems={'center'} justifyContent={'space-between'} style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                <Grid mb={3}>
                    <div className="accordianTitleWrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M11.2527 3.3804C10.9036 3.3804 10.6206 3.09739 10.6206 2.74832V2H9.01905V2.74832C9.01905 3.09739 8.73604 3.3804 8.38698 3.3804H7.31104V4.69642H12.3287V3.3804H11.2527ZM20.9855 6.64541C20.535 6.29861 19.8865 6.38248 19.5397 6.83291L19.3058 7.13631L20.9357 8.39921L21.173 8.09077C21.5198 7.64076 21.4355 6.99221 20.9855 6.64541Z"
                                fill="#006CDD"
                            />
                            <path
                                d="M6.23812 12.473H13.4017C13.4637 12.473 13.5235 12.4823 13.5802 12.499L17.0257 8.02506V5.12614C17.0257 4.17782 16.2541 3.40633 15.3059 3.40633H13.5928V5.32848C13.5928 5.67755 13.3097 5.96056 12.9607 5.96056H6.67875C6.32968 5.96056 6.04667 5.67755 6.04667 5.32848V3.40625H4.33358C3.38526 3.40625 2.61377 4.17778 2.61377 5.12606V20.2801C2.61377 21.2285 3.3853 22 4.33358 22H15.3058C16.2541 22 17.0256 21.2284 17.0256 20.2801V15.5473L16.4398 16.3079C16.3495 16.4255 16.2205 16.5074 16.0757 16.5392L13.5453 17.0997C13.5005 17.1097 13.4547 17.1148 13.4088 17.1148C13.2455 17.1148 13.0886 17.0517 12.9708 16.9386C12.8531 16.8255 12.7837 16.6712 12.7771 16.508L12.6726 13.9182C12.6704 13.8572 12.677 13.7963 12.6922 13.7372H6.23812C5.88906 13.7372 5.60605 13.4542 5.60605 13.1051C5.60605 12.756 5.88902 12.473 6.23812 12.473ZM6.23812 15.8506H10.3877C10.7368 15.8506 11.0198 16.1336 11.0198 16.4826C11.0198 16.8317 10.7368 17.1147 10.3877 17.1147H6.23812C5.88906 17.1147 5.60605 16.8317 5.60605 16.4826C5.60605 16.1336 5.88906 15.8506 6.23812 15.8506ZM6.23812 9.09545H13.4017C13.7507 9.09545 14.0337 9.37846 14.0337 9.72753C14.0337 10.0766 13.7507 10.3596 13.4017 10.3596H6.23812C5.88906 10.3596 5.60605 10.0766 5.60605 9.72753C5.60605 9.37846 5.88902 9.09545 6.23812 9.09545Z"
                                fill="#006CDD"
                            />
                            <path d="M18.5347 8.13818L13.9453 14.0971L14.0098 15.7022L15.5786 15.3549L20.1642 9.40065L18.5347 8.13818Z" fill="#006CDD" />
                        </svg>
                        <Typography className="accordianTitle">Notes & Recommendations</Typography>
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <Controller
                        name="recommendationNotes"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                fullWidth
                                multiline
                                rows={3}
                                placeholder={recommendationPlaceholder}
                                sx={{
                                    '& .MuiInputBase-input::placeholder': {
                                        fontWeight: 400,
                                        lineHeight: '130%',
                                        letterSpacing: '0.15px',
                                        color: '#9E9E9E',
                                        opacity: 1,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        padding: '12px!important',
                                        '& fieldset': {
                                            border: '1px solid rgba(0, 0, 0, 0.10)',
                                            boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                        },
                                    },
                                }}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default AddNotesSection;
